module.exports = __webpack_public_path__ + "static/media/18ECA42.6ec18875.jpg";